<nav class="left" aria-label="Primary navigation">
  <a routerLink="/search" aria-label="shop all activewear" routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">
    Shop All
  </a>
  <a routerLink="/collection/{{newArrivalsNo}}" aria-label="new arrivals" routerLinkActive="active">
    New In
  </a>
  <a routerLink="/collection/{{bestSellersNo}}" aria-label="best sellers" routerLinkActive="active">
    Best Sellers
  </a>
  <a routerLink="/about-us" aria-label="about {{appname}}" routerLinkActive="active">About</a>
  <app-main-menu-button></app-main-menu-button>
</nav>

<div class="center">
  <a routerLink="/" aria-label="Home Page">
    <!-- <app-logo [size]="38"></app-logo> -->
    <app-site-name></app-site-name>
  </a>
</div>

<!-- <nav role="navigation">
  <ul>
    <li><a routerLink="/" aria-label="Home Page">Home</a></li>
    <li>
      <a routerLink="/search" [queryParams]="{category_ids:1}">Dresses</a>
    </li>
    <li><a routerLink="/search" [queryParams]="{category_ids:2}">Tops</a></li>
    <li><a routerLink="/search">Shop</a></li>
    <li><a routerLink="/about-us">About</a></li>
  </ul>
</nav> -->
<div class="right" aria-label="Shopping tools">
  <app-search-button></app-search-button>
  <app-shopping-cart-button></app-shopping-cart-button>
  <app-auth-button></app-auth-button>
</div>
